import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import GetNewsList from "../components/GetNewsList";
import { getNews } from "../services/newsService";
import Layout from "../pages/Layout";
import { Helmet } from "react-helmet";

const GetNews = () => {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [totalRecords, setTotalRecords] = useState(0);
  const { category, query } = useParams();
  const searchTerm = query ? query.replace(/-/g, " ") : ""; // Convert back to spaces
  const pageSize = 8;

  useEffect(() => {
    fetchNews();
  }, [searchTerm, category]); // Refetch when search or category changes

  const fetchNews = async () => {
    setLoading(true);
    try {
      const requestData = {
        PageNumber: 1,
        PageSize: pageSize,
        Slug: category, // Pass selected category
        Filtertext: searchTerm, // Pass search query
      };

      const response = await getNews(requestData);
      if (response.success) {
        setNews(response.newsPagedResult.data);
        setTotalRecords(response.newsPagedResult.totalRecords);
      }
    } catch (error) {
      console.error("Error fetching news:", error);
    }
    setLoading(false);
  };

  return (
    <div className="news-container">
      <Helmet>
              <title>Stay updated with the latest news, breaking headlines, business insights, entertainment, and more at Factbazaar</title>
              <meta name="description" content="Stay updated with the latest news, breaking headlines, business insights, entertainment, and more at Factbazaar." />
              <meta name="keywords" content="latest news, breaking news, business news, entertainment news, world news, Factbazaar" />
              <meta name="author" content="Factbazaar Team" />
              <meta property="og:title" content="Home - Factbazaar" />
              <meta property="og:description" content="Your go-to source for the latest and most reliable news updates." />
              <meta property="og:type" content="website" />
              <meta property="og:url" content="https://www.factbazaar.com/" />
              <meta property="og:image" content="https://www.factbazaar.com/logo.png" />
                        </Helmet>
      <Layout>
      {loading ? (
        <div className="text-center py-3">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : news.length > 0 ? (
      <div className="news-content">
        <GetNewsList
          initialNews={news}
          totalRecords={totalRecords}
        />
      </div> ): (
        <div className="text-center text-muted py-3">No News found.</div>
      )}
      </Layout>
    </div>
  );
};

export default GetNews;
